import { LoginButton } from "@components/header/components/Actions";
import { Heading } from "@components/ui/Heading/Heading";
import { useAuth } from "@context/authContext";

import { useCheckoutContext } from "./Checkout.hooks";

export default function CheckoutHeading() {
  const { dictionary } = useCheckoutContext();
  const { auth } = useAuth();

  return (
    <section>
      <div className="flex items-center justify-between p-4 lg:py-8">
        <Heading as="h1" size={5}>
          {dictionary.yourCart}
        </Heading>
        {!auth?.user && (
          <p className="hidden text-sm uppercase md:block">
            {dictionary.alreadyHaveAnAccount}{" "}
            <LoginButton
              className="inline-block uppercase underline"
              redirectOnSuccess={false}
            >
              {dictionary.login}
            </LoginButton>
          </p>
        )}
      </div>
      <div className="hidden w-full pb-2 pr-5 uppercase child:text-sm child:text-color-base lg:grid lg:grid-cols-8">
        <p className="col-start-6 text-center">{dictionary.quantity}</p>
        <p className="text-end">{dictionary.pricePerItem}</p>
        <p className="text-end">{`${dictionary.total} (${dictionary.vatIncluded})`}</p>
      </div>
    </section>
  );
}
